<script lang="ts" setup>

  type Props = {
    holeNumber?: number
    matchDesktop?: boolean
    selected?: boolean
  }

  const props = withDefaults(defineProps<Props>(), {
    holeNumber: 9,
  })

</script>

<template>
  <div
    class="c-hole-number-component"
    :class="{ selected: props.selected }"
  >
    <span>
      {{ props.holeNumber }}
      <SvgIcon
        icon="hole"
        :width="props.matchDesktop ? 12 : 8"
        :height="props.matchDesktop ? 18 : 12"
      /></span>
  </div>
</template>

<style scoped>

.c-hole-number-component {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0.25em;
  border-radius: 4px;
  background-color: var(--color-secondary-light);

  &:not(:last-child) {
    margin-right: 0.25em;
  }

  span {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    color: var(--color-secondary);
    font-family: Open-Sans, sans-serif;
    font-size: 0.875em;
    font-weight: 600;
    opacity: 0.8;

    .c-icon {
      margin-left: 0.25rem;
    }
  }

  &.selected {
    background-color: var(--color-primary);

    span {
      color: white;
      opacity: 1;
    }
  }

  @media screen and (width >= 1024px) {
    color: var(--color-secondary);
    font-family: Open-Sans, sans-serif;
    font-size: 1.125em;
    font-weight: 600;
  }
}
</style>
